const service = function (
	Http,
	_,
	$q,
	$filter,
	Session,
	growl,
	api
) {
	"ngInject";

	let list = Session.get('favoriteList') ? Session.get('favoriteList') : [];

	this.get = () => {
		return Http.get('/v1/user/favorites').then(res => {
			Session.set('favoriteList', res.map(favorite => parseInt(favorite.id)));
			return $q.resolve(res);
		});
	};
	
	this.add = (id) => {
		return Http.post('/v1/user/favorite', 'POST', { id: id }).then(res => {
			list = res.map(id => parseInt(id));
			if (list.indexOf(parseInt(id)) > -1) {
				growl.success($filter('translate')('growl_favorite_product_added'));
			}
			Session.set('favoriteList', list);
			return $q.resolve(res);
		});
	}

	this.clear = () => {
		return Http.post('/v1/user/favorites', 'DELETE').then(res => {
			Session.set('favoriteList', []);
			return $q.resolve(res);
		});
	};
	
	this.inList = (uid) => list.indexOf(parseInt(uid)) > -1;
}

export default service;


// WEBPACK FOOTER //
// ./app/components/favoriteButton/favorite.service.js